import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const ClickRight: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'ClickRight'
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="11"
        height="9"
        viewBox="0 0 11 9"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.00419 0.170854C6.23199 -0.0569515 6.60134 -0.0569515 6.82915 0.170854L10.3291 3.67085C10.557 3.89866 10.557 4.26801 10.3291 4.49581L6.82915 7.99581C6.60134 8.22362 6.23199 8.22362 6.00419 7.99581C5.77638 7.76801 5.77638 7.39866 6.00419 7.17086L8.50838 4.66667H0.583333C0.261167 4.66667 0 4.4055 0 4.08333C0 3.76117 0.261167 3.5 0.583333 3.5H8.50838L6.00419 0.995812C5.77638 0.768007 5.77638 0.39866 6.00419 0.170854Z"
          fill="#ffffff"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default ClickRight
